import { DateTime } from 'luxon';
import { getDayOfMonth, addPeriodOfTime } from '../../../../../../../services/datetime-service';
import { useSellerFormattedDate } from '../../../../../../../hooks/use-datetime-formats';

const randomISOString = '2022-06-23T21:01:54.008Z';

export const useGetStampsBillingDate = (
  stampsAccountCreatedDateTimeUTC = randomISOString,
  ssSubscriptionEndDateTimeUTC = randomISOString,
) => {
  // createDateTimeUTC <- date stamps account was created, day of month is operative
  // endDateTimeUTC <- date SS subscription will end
  const ONE_MONTH = 1;

  const stampsBillingDay = getDayOfMonth(stampsAccountCreatedDateTimeUTC);
  const ssSubscriptionEndDay = getDayOfMonth(ssSubscriptionEndDateTimeUTC);
  const willStampsStartBillingInSameMonth = ssSubscriptionEndDay <= stampsBillingDay;

  const ssSubscriptionEndDateTime = DateTime.fromISO(ssSubscriptionEndDateTimeUTC);

  const dateOfStampsAccountConversion = willStampsStartBillingInSameMonth
    ? ssSubscriptionEndDateTime.set({ day: stampsBillingDay })
    : ssSubscriptionEndDateTime.set({ day: stampsBillingDay }).plus({ month: ONE_MONTH });

  const stampsBillingDate = addPeriodOfTime(dateOfStampsAccountConversion, {
    period: 'month',
    value: ONE_MONTH,
  });
  const formattedStampsBillingDate = useSellerFormattedDate(stampsBillingDate.toISO());
  return formattedStampsBillingDate;
};
